"use client";

import { RouteError } from "@/components/shared/route-error";

export default function FestivalsError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<RouteError
			error={error}
			reset={reset}
			context="Festivals"
			description="We encountered an error while loading festivals. This might be temporary."
			fallbackUrl="/festivals"
			fallbackLabel="Refresh page"
		/>
	);
}
